<template>
  <div class="Evaluation-modal-overlay">
        <transition name="modal-expand">
        <div v-if="isVisible" class="Evaluation-modal" @click.stop>
      <div class="modal-content">
        <font-awesome-icon class="window-close-icon" :icon="['fas', 'window-close']" @click="close" />
        <h2>Edit {{ $labels.project }} ID: {{ newProject.project_id }}</h2>
          <div class="flex-grow-1 d-flex justify-content-center" style="margin-bottom: 20px;">
              <div v-if="isDisabled" class="expired-box">
                  This session has locked. Session details can no longer be edited.
              </div>
          </div>
        <div class="add">
          <form @submit.prevent="updateProject">
            <div class="form-group">
              <label for="name">Name:</label>
              <input type="text" class="form-control rounded" id="name" name="name" placeholder="Enter Name"
                v-model="newProject.name" :disabled="isDisabled"/>
            </div>
            <div class="form-group">
              <label for="start_date">Start Date:</label>
              <input type="date" class="form-control rounded" id="start_date" name="start_date" placeholder="DD/MM/YYYY"
                v-model="newProject.start_date" :disabled="isDisabled"/>
            </div>
            <div class="form-group">
              <label for="end_date">End Date:</label>
              <input type="date" class="form-control rounded" id="end_date" name="end_date" placeholder="DD/MM/YYYY"
                v-model="newProject.end_date" :disabled="isDisabled"/>
            </div>
            <div class="form-group">
              <label for="location">Location:</label>
              <input type="text" class="form-control rounded" id="location" name="location" placeholder="Enter Location"
                v-model="newProject.location" :disabled="isDisabled"/>
            </div>
            <div class="form-group buttons">
            <button type="button" class="ins-assign-button" @click="viewAssignInstructors" :disabled="isDisabled">Assign Instructors</button>
            <button type="button" class="ins-assign-button" @click="viewAssignTrainees" :disabled="isDisabled">Assign Trainees</button>
          </div>

          <fieldset class="logbook-details-box">
              <legend class="cell-header">Instructors</legend>
              <div class="trainee-container">
                <div v-if="instructorNames.length === 0" class="trainee-box-red">
                  No instructors assigned
                </div>
                <div v-else v-for="(name, index) in instructorNames" :key="index" class="trainee-box">
                  {{ name }}
                </div>
              </div>
            </fieldset>
            <fieldset class="logbook-details-box">
              <legend class="cell-header">Trainees</legend>
              <div class="trainee-container">
                <div v-if="traineeNames.length === 0" class="trainee-box-red">
                  No trainees assigned
                </div>
                <div v-else v-for="(name, index) in traineeNames" :key="index" class="trainee-box">
                  {{ name }}
                </div>
              </div>
            </fieldset>

            <div v-if="showAlert" class="alert alert-danger error-message" role="alert">
              <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
            </div>
            <div class="button-container">
            <button class="ins-close-button" @click="close()">Close</button>
            <button class="btn btn-primary rounded" type="submit" style="margin-right: 5%;" :disabled="isDisabled">Update {{ $labels.project }}</button>
          </div>
          </form>
        </div>
      </div>
      <assign-trainee-modal v-if="showAssignTraineeModal" :selectedProjectId="selectedProjectId" @close="closeAssignTraineeModal"></assign-trainee-modal>
      <assign-instructor-modal v-if="showAssignInstructorModal" :selectedProjectId="selectedProjectId" @close="closeAssignInstructorModal"></assign-instructor-modal>
    </div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios';
import AssignTraineeModal from './AssignTraineeModal.vue';
import AssignInstructorModal from './AssignInstructorModal.vue';

export default {
  name: 'EditProjectModal',
  props: {
    project: {
      type: Object,
      required: true,
    },
    assignedUsers: {
      type: Array,
      required: true,
    },
    status: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    AssignTraineeModal,
    AssignInstructorModal,
  },
  data() {
    return {
      role: localStorage.getItem('role'),
      localAssignedUsers: [],
      newProject: {
        name: '',
        start_date: '',
        end_date: '',
        location: '',
        product_id: '',
      },
      showAlert: false,
      errorMessage: '',
      showAssignTraineeModal: false,
      showAssignInstructorModal: false,
      selectedProjectId: localStorage.getItem('project_id'),
      isVisible: false,
    };
  },
  computed: {
    traineeNames() {
      return this.localAssignedUsers
        .filter(user => user.role === 'trainee')
        .map(user =>
          user.first_name && user.last_name
            ? `${user.first_name} ${user.last_name}`
            : 'Unknown'
        );
    },
    instructorNames() {
      return this.localAssignedUsers
        .filter(user => user.role === 'instructor')
        .map(user =>
          user.first_name && user.last_name
            ? `${user.first_name} ${user.last_name}`
            : 'Unknown'
        );
    },
    isDisabled() {
      return this.status === 1;
    },
    minDate() {
      return new Date().toISOString().split('T')[0];
    }
  },
  methods: {
    async updateProject() {
      try {
        const project_id = localStorage.getItem('project_id');
        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };
        console.log('product_id')
        console.log(this.newProject);

        const response = await axios.put(
          `/api/projects/${project_id}`,
          {
            name: this.newProject.name,
            start_date: this.newProject.start_date,
            end_date: this.newProject.end_date,
            location: this.newProject.location,
            product_id: this.newProject.product_id,
          },
          { headers }
        );

        if (response.status === 200) {
          window.alert(`${this.$labels.project} updated Successfully`);
          this.newProject = {
            name: '',
            start_date: '',
            end_date: '',
            location: '',
            product_id: '',
          };
          this.errorMessage = '';
          this.showAlert = false;
        }
        this.close();
      } catch (error) {
        console.error('Error updating Project:', error.response);
        if (error.isOffline === true) {
            this.$router.push({ name: 'ViewProjects' });
          return;
        }

        if (error.response && error.response.data && error.response.data.errors) {
          // Handle validation errors
          const validationErrors = error.response.data.errors;

          // Build an error message from the validation errors
          let errorMessage = 'Validation errors:';
          for (const field in validationErrors) {
            errorMessage += `\n${field}: ${validationErrors[field][0]}`;
          }

          this.errorMessage = errorMessage;
        } else {
          // Handle other errors
          this.errorMessage = `An error occurred while updating the ${this.$labels.project}.`;
        }

        this.showAlert = true;
      }
    },
    async fetchUsers(project_id) {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          console.error('Unauthorized access');
          return;
        }
        const headers = { Authorization: `Bearer ${token}` };
        console.log('here');

        const response = await axios.get(`/api/projects/${project_id}/users`, { headers });

        console.log('response', response);

        if (response.status === 200) {
          this.localAssignedUsers = response.data.map(user => ({
            ...user,
            role: user.pivot.role,
          }));
        }
      } catch (error) {
        console.error('Error retrieving users:', error);
      }
    },
    close() {
      this.$emit('close'); // Emit an event to indicate the modal should be closed
    },
    loadProjectData() {
      const formatDate = (date) => {
        if (!date) return '';

        // Already YYYY-MM-DD
        if (/^\d{4}-\d{2}-\d{2}$/.test(date)) return date;

        // DD/MM/YYYY
        const [day, month, year] = date.split('/');
        return `${year}-${month}-${day}`;
      };

      this.newProject = {
        ...this.project,
        start_date: formatDate(this.project.start_date),
        end_date: formatDate(this.project.end_date),
      };
    },
    viewAssignTrainees() {
      this.showAssignTraineeModal = true; // Show the modal when the button is clicked
    },
    closeAssignTraineeModal() {
      this.showAssignTraineeModal = false; // Close the modal
      this.fetchUsers(this.newProject.project_id);
    },
    viewAssignInstructors() {
      this.showAssignInstructorModal = true; // Show the modal when the button is clicked
    },
    closeAssignInstructorModal() {
      this.showAssignInstructorModal = false; // Close the modal
      this.fetchUsers(this.newProject.project_id);
    },
  },
  async mounted() {
    this.isVisible = true;
    this.localAssignedUsers = [...this.assignedUsers];
    this.loadProjectData();
  },
}
</script>

<style scoped>
h2 {
  margin-top: 10px;
  font-size: 30px;
  margin-bottom: 30px;
}

.Evaluation-modal-overlay {
  position: fixed;
  top: 0px;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100vh;
  z-index: 1;
}

.Evaluation-modal {
  background-color: #ffffff;
  overflow-y: auto;
  /* Enables vertical scrolling if needed */
  margin-top: 25px;
  max-height: 95vh;
  width: min(90vw, 1200px);
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  position: fixed;
  display: flex;
  flex-direction: column;
  overflow-wrap: break-word;
  padding: 20px;
  z-index: 1002;
}

.modal-content {
  position: relative;
  max-height: 90vh;
  overflow-y: auto;
  padding: 15px;
}

@media (max-width: 768px) {

  /* Adjust the max-width as needed for iPad or other tablet sizes */
  .Evaluation-modal {
    padding: 5px;
    font-size: 0.9em;
    /* Reduce font size */
  }

  /* Further adjustments for other elements */
}



.alert {
  position: relative;
  padding: .75rem 1.25rem;
  margin-bottom: 0rem;
  border: 1px solid transparent;
  border-radius: .25rem;
}



button.btn:hover {
  background-color: #0c1a61;
  transition: transform 0.2s, box-shadow 0.2s;
}

.form-control.rounded {
    height: 40px;
}

.form-group {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.form-group label {
    width: 150px;
    margin-right: 50px;
    text-align: right;
    margin-bottom: 0px;
}

.form-group input.form-control,
.form-group select.form-control {
    flex: 1;
    width: auto;
    margin-left: 0;
    margin-bottom: 0px;
    border: 1px solid #cccccc;
}

.form-control {
    border-radius: 5px;
}

#start_date,
#end_date {
    flex: 0 0 180px;
    /* don't grow, don't shrink, fixed 100px */
    width: 180px;
}

.form-group.buttons {
    justify-content: center;
    /* center horizontally */
    gap: 15px;
    /* space between buttons */
}

h1 {
  margin-bottom: 50px;
}

.button-container {
  display: flex;
  justify-content: space-between;
  /* Aligns items to the right */
  align-items: center;
  margin-top: 0px;
  /* Adjust as needed */
}

.ins-close-button {
  background-color: #6c757d;
  border: 1px solid #4d5358;
  color: white;
  width: 120px;
  padding: 5px 20px;
  border-radius: 5px;
  margin-left: 5%;
}

.ins-close-button:hover {
  background-color: #4d5358;
}

.logbook-details-box {
  border: 2px solid #858585;
  border-radius: 5px;
  margin: 3px auto;
  min-width: 95%;
  max-width: 95%;
  padding: 7px;
  margin-bottom: 20px;
}


.cell-header {
  font-weight: bold;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  font-size: 12px;
  background-color: #707070;
  padding: 2px 5px;
  color: white;
  border-radius: 2px;
  margin-bottom: 5px;
  margin-top: -20px;
  /* Set margin-right */
  text-align: left;
  display: inline-block;
  width: auto;
}

.trainee-container {
  display: flex;
  flex-wrap: wrap;
  /* Allows wrapping */
}

.trainee-box {
  display: inline-block;
  padding: 4px 12px;
  margin: 3px;
  border-radius: 8px;
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  text-align: center;
  white-space: nowrap;
  font-size: 14px;
}

.trainee-box-red {
  display: inline-block;
  padding: 4px 12px;
  margin: 3px;
  border-radius: 8px;
  background-color: #ffd3d3;
  border: 1px solid #f84c4c;
  color: rgb(195 0 0);
  text-align: center;
  white-space: nowrap;
  font-size: 14px;
}

.ins-assign-button {
  margin-top: 0px;
  margin-bottom: 0px;
  margin-left: 15px;
  margin-right: 15px;
  border-radius: 5px;
  background-color: rgb(53, 131, 37);
  border: 1px solid rgb(26, 82, 16);
}

.ins-assign-button:hover {
  background-color: rgb(48, 112, 35);
  border: 1px solid rgb(23, 77, 13);
}

.ins-assign-button:disabled {
    background-color: #797979;
    border: 1px solid #3d3d3d;
    cursor: not-allowed;
    color: white;
    transition: none;
    transform: none;
}

input:disabled,
button:disabled {
  cursor: not-allowed;
  border: 1px solid #ddd;
  opacity: 0.5;
  transition: none;
  transform: none;
}
</style>